import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from './context/LanguageContext';
import { ChatWidget } from './components/ChatWidget';
import { ScrollToTopOnRouteChange } from './components/ScrollToTopOnRouteChange';
import HomePage from './pages/HomePage';
import AcademyPage from './pages/AcademyPage';
import CoachPage from './pages/CoachPage';
import CourtsPage from './pages/CourtsPage';
import GolfPage from './pages/GolfPage';
import ProShopPage from './pages/ProShopPage';
import EventsPage from './pages/EventsPage';
import SportsBarPage from './pages/SportsBarPage';
import RealEstatePage from './pages/RealEstatePage';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTopOnRouteChange />
        <Toaster position="top-center" richColors />
        <ChatWidget />
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/academy" element={<AcademyPage />} />
            <Route path="/coach/:slug" element={<CoachPage />} />
            <Route path="/courts" element={<CourtsPage />} />
            <Route path="/golf" element={<GolfPage />} />
            <Route path="/pro-shop" element={<ProShopPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/sports-bar" element={<SportsBarPage />} />
            <Route path="/immobilien" element={<RealEstatePage />} />
            <Route path="/real-estate" element={<RealEstatePage />} />
            <Route path="/immobilier" element={<RealEstatePage />} />
            <Route path="/inmobiliaria" element={<RealEstatePage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
